export default {
  get_all: { method: "get", url: "api/categorias" },
  show: { method: "get", url: "api/categorias{/id}" },
  store: { method: "post", url: "api/categorias" },
  update: { method: "put", url: "api/categorias{/id}" },
  delete: { method: "delete", url: "api/categorias{/id}" },
  to_select: { method: "get", url: "api/categorias/to-select" },
};
